module.exports = "/dist/42de89835eafdcf69210bb254061b4e9.woff";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-roboto/files/roboto-latin-100italic.woff
// module id = 146
// module chunks = 0